module.exports = __webpack_public_path__ + "static/media/mujer-hombre3.55c6cecd.jpg";